<div class="align-items-center"
     style="color: #ffffff; width: 100%; margin: 60px auto; text-align: center;">
  Loading...
</div>
